import { render, staticRenderFns } from "./ApplicantSupplierOnboardingStepPage.vue?vue&type=template&id=62548f3d&"
import script from "./ApplicantSupplierOnboardingStepPage.vue?vue&type=script&lang=js&"
export * from "./ApplicantSupplierOnboardingStepPage.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantSupplierOnboardingStepPage.vue?vue&type=style&index=0&id=62548f3d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports